import { render } from "./InventoryImplementationView.vue?vue&type=template&id=0d1e8486"
import script from "./InventoryImplementationView.vue?vue&type=script&lang=js"
export * from "./InventoryImplementationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__